export default "__VITE_ASSET__CgS8K8G6__"